<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("fastmovingreport") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="getRecipeReportsSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getRecipeReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onRecipeReportDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="getSelectedWeekDay ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("day", 1) }}</label
              >
              <b-dropdown
                :text="getSelectedWeekDay"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in getWeekDaysList"
                  :key="dropdownIndex"
                  @click="
                    onRecipeReportDropDownHandler({
                      event: $event,
                      name: 'isDays',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    })
                  "
                  >{{ dropdownItem.wd_day }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button @click="onFetchFastMovingReports" class="btn-blue-lg w-100">
              {{ $tc("getReport") }}
            </button>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center d-flex justify-content-end align-items-center">
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="getPDFRecord"
            :href="BASE_URL + getPDFRecord"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a
            v-if="getExcelRecord"
            :href="BASE_URL + getExcelRecord"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>

        </div>
      </div>

      <div class="swc-report">

        <!--new design start-->
        <table class="new-table w-100">
  <col>
  <colgroup span="2"></colgroup>
  <colgroup span="2"></colgroup>
  <tr  class="bg-lightgrey">
    <td rowspan="2" class="font-weight-bold">Items</td>
    <th colspan="2" scope="colgroup" class="d-none"></th>
    <th colspan="6" scope="colgroup" class="text-center">{{ $tc("unit") }}</th>
  </tr>
  <tr  class="bg-lightgrey text-center">
    <th scope="col">{{ $tc("qty") }} {{ $tc("sold") }}</th>
    <th scope="col">
                    <img
                        @click="
                          onSortValue({
                            name: 'net_price',
                            type: getOrder == 'asc' ? 'desc' : 'asc'
                          })
                        "
                        src="@/assets/img/icons/sort.svg"
                        class="cursor-pointer"
                        width="15px"
                        height="20px"
                      />{{ $tc("net") }} {{ $tc("price") }}</th>
    <th scope="col">{{ $tc("cost") }} {{ $tc("price") }}</th>
    <th scope="col">{{ $tc("std") }} {{ $tc("profit") }}</th>
    <th>  
      <img
                        @click="
                          onSortValue({
                            name: 'std_profit%',
                            type: getOrder == 'asc' ? 'desc' : 'asc'
                          })
                        "
                        src="@/assets/img/icons/sort.svg"
                        class="cursor-pointer"
                        width="15px"
                        height="20px"
                      />{{ $tc("std") }} {{ $tc("profit") }} %</th>
  </tr>
  <tr v-if="getFastMovingReports && getFastMovingReports.length == 0">
              <td colspan="6">
                <!-- <p class="text-center h6 mb-0">
                  {{ $tc("NoRecords") }}
                </p> -->
                <NoRecords />
              </td>
            </tr>
  <tr 
      v-else-if="getFastMovingReports && getFastMovingReports.length > 0"
  v-for="(fnbItems, fnbItemsKey) in getFastMovingReports"
  :key="fnbItemsKey">
    <th scope="row" class="text-left">{{ fnbItems.item_name }}</th>
   
      <td class="text-right">{{ fnbItems.qty_sold }}</td>
      <td class="text-right">{{ currFormat(fnbItems.sum_net_amount) }}</td>
      <td class="text-right">{{ currFormat(fnbItems.cost_price) }}</td>
      <td class="text-right">{{ currFormat(fnbItems.std_profit) }}</td>
      <td class="text-right">{{ currFormat(fnbItems.std_profit_percentage) }}</td>
      
      <tr class="bg-lightgrey" v-if="getFastMovingReports && getFastMovingReports.length > 0">
                    <td class="text-left font-weight-bold">Total</td>
                    <th class="text-right">{{ getFastMovingReportsTotal.qtySold }}</th>
                    <th class="text-right">
                      {{ currFormat(getFastMovingReportsTotal.net_amount) }}
                    </th>
                    <th class="text-right">
                      {{ currFormat(getFastMovingReportsTotal.cost_price) }}
                 <!-- {     getFastMovingReports.reduce((acc,{cost_price}) => {
                        return +parseFloat(acc + cost_price)
                      },0).toFixed(2)} -->
                    </th>
                    <th class="text-right">
                      {{ currFormat(getFastMovingReportsTotal.std_profit) }}
                    </th>

                    <th class="text-right">
                      {{
                        currFormat(
                          getFastMovingReportsTotal.std_profit_percentage
                        )
                      }}
                    </th>
                  </tr>
  </tr>

</table>


          <!--new design end-->

        <!--Old DEsign start-->
        <table class="swc-report-table" border="1" v-if="false">
          <thead class="bg-lightgrey">
            <tr>
              <th class="text-left" style="border-bottom:1px solid transparent;">{{ $tc("items") }}</th>
              <th>{{ $tc("unit") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-lightgrey">
              <td class="p-0 text-left"></td>
              <td class="p-0">
                <table class="w-100">
                  <tr>
                    <td class="text-left">
                      {{ $tc("qty") }} {{ $tc("sold") }}
                    </td>
                    <td class="d-flex align-items-center border-left" >
                      <img
                        @click="
                          onSortValue({
                            name: 'net_price',
                            type: getOrder == 'asc' ? 'desc' : 'asc'
                          })
                        "
                        src="@/assets/img/icons/sort.svg"
                        class="cursor-pointer"
                        width="15px"
                        height="20px"
                      />{{ $tc("net") }} {{ $tc("price") }}
                    </td>
                    <td class="border-left">{{ $tc("cost") }} {{ $tc("price") }}</td>
                    <td class="border-left">{{ $tc("std") }} {{ $tc("profit") }}</td>

                    <td
                      class="d-flex align-items-center justify-content-end text-end"
                    >
                      <img
                        @click="
                          onSortValue({
                            name: 'std_profit%',
                            type: getOrder == 'asc' ? 'desc' : 'asc'
                          })
                        "
                        src="@/assets/img/icons/sort.svg"
                        class="cursor-pointer"
                        width="15px"
                        height="20px"
                      />{{ $tc("std") }} {{ $tc("profit") }} %
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr v-if="getFastMovingReports && getFastMovingReports.length == 0">
              <td colspan="2">
                <!-- <p class="text-center h6 mb-0">
                  {{ $tc("NoRecords") }}
                </p> -->
                <NoRecords />
              </td>
            </tr>
            <tr
              v-else-if="
                getFastMovingReports && getFastMovingReports.length > 0
              "
            >
              <td class="text-left p-0" style="border:none;">
                <table class="w-100">
                  <tr
                    v-for="(fnbItems, fnbItemsKey) in getFastMovingReports"
                    :key="fnbItemsKey"
                    class="border-bottom border-right"
                  >
                    <td>{{ fnbItems.item_name }}</td>
                  </tr>
                  <tr>
                    <td class="bg-lightgrey font-weight-bold">Total</td>
                  </tr>
                </table>
              </td>
              <td class="p-0" style="border:none;">
                <table class="w-100">
                  <tr
                    v-for="(fnbItems, fnbItemsKey) in getFastMovingReports"
                    :key="fnbItemsKey"
                  >
                    <td>{{ fnbItems.qty_sold }}</td>
                    <td>{{ currFormat(fnbItems.sum_net_amount) }}</td>
                    <td>{{ +parseFloat(fnbItems.cost_price) }}</td>
                    <td>{{ currFormat(fnbItems.std_profit) }}</td>
                    <td>{{ currFormat(fnbItems.std_profit_percentage) }}</td>
                  </tr>
                  <tr class="bg-lightgrey" style="border-top: 1px solid black">
                    <th>{{ getFastMovingReportsTotal.qtySold }}</th>
                    <th>
                      {{ currFormat(getFastMovingReportsTotal.net_amount) }}
                    </th>
                    <th>
                      <!-- {{ currFormat(getFastMovingReportsTotal.cost_price) }} -->
                      <!-- {{
                      getFastMovingReports.reduce((acc,{cost_price}) => {
                        return +parseFloat(acc + cost_price)
                      },0).toFixed(2)
                      }} -->
                    </th>
                    <th>
                      {{ currFormat(getFastMovingReportsTotal.std_profit) }}
                    </th>

                    <th>
                      {{
                        currFormat(
                          getFastMovingReportsTotal.std_profit_percentage
                        )
                      }}
                    </th>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <!--Old DEsign Ends-->
       
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords
  },
  data() {
    return {
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: ""
    };
  },
  computed: {
    ...mapGetters([
      "getCinemasList",
      "getWeekDaysList",
      "getRecipeReportsSelectedCinema",
      "getSelectedWeekDay",
      "getFastMovingReports",
      "getFastMovingReportsTotal",
      "getPDFRecord",
      "getExcelRecord",
      "getOrder"
    ])
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    // this.fetchCinemasList();
    this.fetchDaysList();
    this.ResetFastMovingReport();
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //   this.onRecipeReportDropDownHandler({
    //     event: null,
    //     name: "isCinema",
    //     selectedItem: CinemaObj
    //   });
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onRecipeReportDropDownHandler({
    //       event: null,
    //       name: "isCinema",
    //       selectedItem: CinemaObj
    //     });
    //   }
    // }
  },
  methods: {
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onRecipeReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "fetchDaysList",
      "onRecipeReportDropDownHandler",
      "ResetFastMovingReport",
      "onFetchFastMovingReports",
      "onSortValue"
    ])
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
  text-align: center;
}
.border-left{
  border-left: 1px solid #000 !important;
}
.border-top{
  border-top: 1px solid #000 !important;
}
.border-right{
  border-right: 1px solid #000 !important;
}
.border-bottom{
  border-bottom: 1px solid #000 !important;
}
.new-table td,th{
  padding: 5px 15px 5px 15px;
  border: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/fastMovingReport.vue